import React, { PropsWithChildren, useMemo } from 'react';
import { TableBodyContext } from './TableBody.context';

type TableHeadProps = {
  className?: string;
  customTableHeadClass?: string;
};

export function TableHead({ className, customTableHeadClass, children }: PropsWithChildren<TableHeadProps>) {
  const ctx = useMemo(() => ({ isTableBody: false }), []);

  return (
    <TableBodyContext.Provider value={ctx}>
      {/* we need redundant roles for responsive tables! */}
      <thead className={customTableHeadClass || `tables__head ${className || ''}`.trim()}>{children}</thead>
    </TableBodyContext.Provider>
  );
}
